import * as React from "react";
import { Button, Label } from "uxp/components";
import { PropertyCard } from "../../ui-props/common";

export interface IMultipleItemsPropertyProperty<T> {
    title:string;
    items:T[];
    render:(item:T,onChange:(newItem:T)=>void)=>React.ReactElement;
    newItem:()=>T;
    onChange:(newItems:T[])=>void;
}
export function MultipleItemsProperty<T>(props:IMultipleItemsPropertyProperty<T>) {

    return <>

        {!!props.items.length &&
            <div className="wd-ui-property-group-title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                {props.title}
            </div>
        }
        {!props.items.length && <Label>No items were added</Label>}
        <div>

            {props.items.map((s, i) => {

                return <PropertyCard
                    key={i}
                    className="ui-field-config-item-col"
                    onRemove={() => {
                        let newItems = props.items.slice();
                        newItems.splice(i, 1);
                        props.onChange(newItems.slice());
                    }}
                >
                    {props.render(s,(ni)=>{
                        props.items[i] = ni;
                        props.onChange(props.items.slice());
                    })}
                </PropertyCard>
            })}
            <Button
                className="new-option"
                title="Add New Item"
                icon={"/Resources/Lucy/lucy-dashboard/assets/images/plus-rounded.svg"}
                iconPosition="right"
                onClick={() => {
                    let items = props.items ||[];
                    items.push(props.newItem());
                    props.onChange([...items]);
                }}
            />

          

        </div>


    </>
}